<template>
  <div class="fs-6">
    <div class="row mb-3">
      <div class="col">
        Dear Parents,<br />
        The application form will take approximately 20-30 minutes to complete. You will need to upload the following documents as part of your application.
        Please prepare them in advance to shorten the time needed to complete the application process.
      </div>
    </div>

    <div class="row">
      <div class="col">Documents checklist</div>
    </div>

    <div>
      <div>1) Copy of child's vaccination record</div>
      <div>2) Copy of 1 passport-sized photograph of your child</div>
      <div>3) Copy of child's Dependant Pass/ Student Pass (if applicable)</div>
      <div>4) Any other relevant medical reports (if applicable)</div>
      <div>5) Screenshot or proof of payment* of the registration fee of {{ preschoolInfo.paymentInfo.registrationFee }}</div>
    </div>
  </div>
</template>

<script>
import { preSchools } from '@/pages/application/data'

export default {
  name: 'ApfPreSupportingDocument',
  props: ['selected', 'schools', 'preschoolInfo'],
  data() {
    return {
      selectedPreSchools: {},
    }
  },
  mounted() {
    this.selectedPreSchools = this.getPreschoolInfo(this.selected)
  },
  watch: {
    selected: function (val) {
      this.selectedPreSchools = this.getPreschoolInfo(val)
    },
  },
  methods: {
    getPreschoolInfo(val) {
      return preSchools.schoolsInfo?.find(d => d.schoolID === val)
    },
  },
}
</script>
